module.exports = __webpack_public_path__ + "static/media/logo_pet_branca.8c0ee946.svg";